import axios from "axios";

export const image_base_url = "https://royalapi.bizautotech.com";

//export const image_base_url = "http://localhost:5170";

const api = axios.create({
  
  baseURL: "https://royalapi.bizautotech.com/api",
  //baseURL: "http://localhost:5170/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    // If FormData, remove default JSON header
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;